export interface IProgram {
  id: number
  uuid: string
  name?: string
  email?: string
  code?: string
  countryCode?: string
  mobileNumber?: string
  companyName? :string
  status: boolean
  createdAt: string
  modifiedAt: string
  deletedAt: any
  programTitle: string
  programCode: string
  shortDescription: any
  testModeEnabled: boolean
  description: string
  programLogo: any
  programManagers: any
  jury: any
  formId: any
  applicationsClosed: boolean
  // SAN-1460 — the Programs badge's stakeholder rule, also applied by the page.
  membershipStakeholderType?: string | null
  applicationStartDate: any
  applicationClosedDate: any
  displayOrder?: number
  programClosed: boolean
  selected?: boolean
  formSubmissions: {}
  applied?: boolean
  registrationLink:string
  source:'external' | 'internal'
  getSubmissionDetails : {
    currentRound: {
      roundName:string
    }
  }
  roundDetail: {
    appliedOn: string
    applicationStatus:string
    currentRound: {
      name:string
      roundName:string
       isPaymentRequired:boolean
       isVideoRequired:boolean
       paymentType:string
       id:number
    }
    isRejected: boolean
    rejectionMessage:string
    submissionStatus:string
    submittedOn: string
    rejectedOn:string

    createdAt?:string
  }
  headerImage: string
  footerImage: string
  allowReapplication: boolean
  reapplicationDurationType: 'days' | 'months' | 'years'
  reapplicationTime: number
  withWithoutProfile: 'with' | 'without'
  programContentSections: ProgramContentSection[]
  programFAQs: ProgramFaq[]

  applicationProgramContentSections:ProgramContentSection[]
  applicationProgramFAQs:ProgramFaq[]
  mobileNumberField: boolean
  form?: {
    uuid:string
  }
  isVideoRequired: boolean
  isPaymentRequired:boolean
  isDocumentRequired:boolean
  paymentType:string
  membershipTypes:MembershipPlans[]
  isPitchDocumentRequired:boolean
  applicationProgramDocumentTypes:ProgramDoc[]
  companyNameField:boolean
  bypassOTPVerification: boolean
  programType:ProgramType
  isProgramChallengeType :string
  partnerId?: number
  partner?:{
    uuid:string
    name:string
    logo:string
  }
 programRequestType:string
 programUrl:string
 promotionRequestId?:number
 partnerPromotions?:PartnerPromotions[]
 promoteWithPartners: number[]
 restrictToRecognitionIdHolders?: boolean
 recognitionIdEligibilityMessage?: string
 // SAN-539: Hub/Spoke provenance badge — additive, optional fields returned by
 // GET public/application-programs-management and GET application-programs-management.
 // isPromoted is false/absent and promotedFromName is null for native/inner-community
 // programs; never rendered until both are present.
 isPromoted?: boolean
 promotedFromName?: string | null

}

export interface PartnerPromotions {
 partner_id: number,
  promotion_id: number
}
export enum ProgramType {
  PROGRAM ='program',
  VS_PROGRAM = 'vs-program',
  CALL_FOR_APPLICATION = 'call-for-application'
}

export interface ProgramContentSection {
  id: number
  programId: number
  title: string
  content: string
  position: number
  status: boolean
}

export interface ProgramFaq {
  id: number
  programId: number
  question: string
  answer: string
  position: number
  status: boolean
}



export interface IProgramApplicationStatus {
  id: number
  uuid: string
  status: boolean
  createdAt: string
  modifiedAt: string
  deletedAt: any
  applicationNumber: string
  submissionId: number
  programId: number
  currentRoundId: any
  completedRounds: any
  isRejected: boolean
  rejectedOn: any
  adminId: any
  rejectionMessage: any
  applicationStatus: string
  submittedOn: string
  submissionStatus: string
  emailSentCount: number
  firstEmailSentAt: any
  currentRound: any
  programRounds: ProgramRound[]
  // SAN-352/353 — CFA reapply-eligibility fields, additive on the
  // round-detail object returned by checkApplicationStatus(showDetails=true).
  // allowReapplication is always present; canReapplyNow/reapplyAvailableOn
  // are only ever populated when isRejected is true and the applicant
  // resolves to a real startup (absent/undefined otherwise).
  allowReapplication?: boolean
  canReapplyNow?: boolean
  reapplyAvailableOn?: string | null
}

export interface ProgramRound {
  id: number
  uuid: string
  roundName: string
  formId: any
}

export interface ProgramDoc{
  
  description: string
  isMandatory:boolean
  fileType:string
  allowedFileTypes:any
  id:number
  name:string
  size:number
  url?: Url
  programId:number,
  programRoundId:number,
  extension: string
  file?: File;
  originalName?: string;
  submissionId?:number;
  submission:IsSubmisson;
}
export interface Url {
  objectUrl: string
}
export interface IsSubmisson {
  approvalStatus:string;
  attachment:string;
  fileName:string;
  id:number;
  rejectedReason:string;
}
// export interface membershipPlans{
//   id:number;
//   uuid:string;
//   name:string;
//   code:string;
//   monthlyPricing:string;
//   quarterlyPricing:string;
//   halfyearlyPricing:string;
//   yearlyPricing:string;
//   lifetimePricing:string;
//   maxYears:number;
// }

export interface MembershipPlans {
  id: number;
  uuid: string;
  status: boolean;
  createdAt: string;   
  modifiedAt: string;  
  deletedAt: string | null;
  name: string;        
  code: string;       
  description: string;
  profileType: string; 

  monthlyPricing: string;
  quarterlyPricing: string;
  halfyearlyPricing: string;
  yearlyPricing: string;
  lifetimePricing: string;

  maxYears: number;
  isHardExpiry: boolean;
  expiryMonth: number | null;

  isTaxIncluded: boolean;
  isActive: boolean;

  isChargesIncluded: boolean;
  chargesTypes: number[] | null;

  isCouponsIncluded: boolean;
  coupons: any | null;

  canBookMultiple: boolean;
  maxDurationForMultipleBooking: number;

  createdBy: number;
  deletedBy: number | null;

  taxProfile?: {
    id: number;
    uuid: string | null;
    status: boolean;
    createdAt: string;
    modifiedAt: string;
    deletedAt: string | null;
    name: string;
    taxPercent: string;
    isGST: boolean;
  } | null;

  charges?: {
    name: string;
    type: "amount" | "percentage";
    value: string;
  }[];
}
